import React from 'react'

const finYearOptions = [2024, 2023, 2022, 2021, 2020]
const mileageOptions = [
  { value: 40000, label: 'bis zu 40.000 km' },
  { value: 80000, label: 'bis zu 80.000 km' },
  { value: 120000, label: 'bis zu 120.000 km' },
  { value: 200000, label: 'ueber 120.000 km' },
]
const mileageOptionLabels = mileageOptions.map((opt) => opt.label)
const finMileageOptions = [
  { value: 50000, label: 'bis zu 50.000 km' },
  { value: 100000, label: 'bis zu 100.000 km' },
  { value: 150000, label: 'bis zu 150.000 km' },
]
const phoneCountries = ['+49', '+43', '+41']
const hsnYearOptions = [2020, 2019]
const hsnMileageOptions = [{ value: 100000, label: 'bis zu 100.000 km' }]

const DesktopModelSteps = () => (
  <div id="desktop-tab-content-model" data-tab-content-group="desktop" data-tab-target="model" className="space-y-0 model-steps">
    <div className="progress-wrap mb-2">
      <div className="progress-track">
        <div id="desktop-model-progress" className="progress-bar" />
      </div>
    </div>
    <div id="desktop-model-step-1" className="form-step active relative">
      <select id="desktop-brand-select" className="brand-select w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Marke auswaehlen</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-2" className="form-step active relative">
      <select id="desktop-model-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Modell auswaehlen</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-3" className="form-step active relative">
      <select id="desktop-year-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Erstzulassung</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-body" className="form-step relative">
      <select id="desktop-body-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Karosserieform</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-4" className="form-step relative">
      <select id="desktop-fuel-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Kraftstoff</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-5" className="form-step relative">
      <select id="desktop-gear-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Schaltung</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-6" className="form-step relative">
      <select id="desktop-power-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Motorleistung</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-7" className="form-step relative">
      <select id="desktop-variant-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Untermodell</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-8" className="form-step relative">
      <input
        id="desktop-mileage-select"
        placeholder="Kilometer"
        inputMode="numeric"
        data-options={JSON.stringify(mileageOptionLabels)}
        className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none"
      />
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-model-step-9" className="form-step space-y-3">
      <input type="email" id="desktop-model-email" placeholder="E-Mail" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none" />
      <div className="flex space-x-2">
        <div className="relative w-1/3">
          <select id="desktop-model-phone-code" className="w-full mobile-input-h pl-3 pr-6 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none truncate">
            <option>+49</option>
            <option>+43</option>
            <option>+41</option>
            <option>+41</option>
          </select>
          <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
          </div>
        </div>
        <input id="desktop-model-phone-prefix" type="text" inputMode="numeric" maxLength={4} placeholder="Vorwahl" className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
        <input id="desktop-model-phone-number" type="text" inputMode="numeric" maxLength={8} placeholder="Telefon-Nr." className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
      </div>
      <div className="text-white text-legal opacity-90">
        Den autoverkaufen.de Nutzungsbedingungen stimme ich zu.
      </div>
      <label className="flex items-start space-x-2 text-white opacity-90 agb-consent">
        <input type="checkbox" className="custom-radio mt-1" />
        <span className="text-legal">Ich bin mit dem Erhalt der Bewertung per E-Mail einverstanden. Mit Anforderung der Online-Bewertung erklaerst du dich mit den AGBs und der Datenschutzerklaerung einverstanden.</span>
      </label>
      <a href="/email-confirm" data-submit-inquiry="true" className="w-full mobile-btn-main-h bg-[#0099ff] text-white radius-24 shadow-lg hover:bg-blue-600 transition text-lg tracking-wide flex items-center justify-center">
        Jetzt kostenlos bewerten!
      </a>
    </div>
  </div>
)

const MobileModelSteps = () => (
  <div id="tab-content-model" data-tab-content-group="mobile" data-tab-target="model" className="space-y-0 model-steps">
    <div className="progress-wrap mb-2">
      <div className="progress-track">
        <div id="mobile-model-progress" className="progress-bar" />
      </div>
    </div>
    <div id="mobile-model-step-1" className="form-step active relative">
      <select id="mobile-brand-select" className="brand-select w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Marke auswaehlen</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-2" className="form-step active relative">
      <select id="mobile-model-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Modell auswaehlen</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-3" className="form-step active relative">
      <select id="mobile-year-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Erstzulassung</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-body" className="form-step relative">
      <select id="mobile-body-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Karosserieform</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-4" className="form-step relative">
      <select id="mobile-fuel-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Kraftstoff</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-5" className="form-step relative">
      <select id="mobile-gear-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Schaltung</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-6" className="form-step relative">
      <select id="mobile-power-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Motorleistung</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-7" className="form-step relative">
      <select id="mobile-variant-select" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Untermodell</option>
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-8" className="form-step relative">
      <input
        id="mobile-mileage-select"
        placeholder="Kilometer"
        inputMode="numeric"
        data-options={JSON.stringify(mileageOptionLabels)}
        className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none"
      />
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="mobile-model-step-9" className="form-step space-y-3">
      <input type="email" id="mobile-model-email" placeholder="E-Mail" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none" />
      <div className="flex space-x-2">
        <div className="relative w-1/3">
          <select id="mobile-model-phone-code" className="w-full mobile-input-h pl-3 pr-6 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none truncate">
            <option>+49</option>
            <option>+43</option>
            <option>+41</option>
            <option>+41</option>
          </select>
          <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
          </div>
        </div>
        <input id="mobile-model-phone-prefix" type="text" inputMode="numeric" maxLength={4} placeholder="Vorwahl" className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
        <input id="mobile-model-phone-number" type="text" inputMode="numeric" maxLength={8} placeholder="Telefon-Nr." className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
      </div>
      <div className="text-white text-legal opacity-90">
        Den autoverkaufen.de Nutzungsbedingungen stimme ich zu.
      </div>
      <label className="flex items-start space-x-3 cursor-pointer agb-consent">
        <input type="checkbox" className="custom-radio mt-1" />
        <span className="text-white text-legal opacity-90">
          Ich bin mit dem Erhalt der Bewertung per E-Mail einverstanden.
          Mit Anforderung der Online-Bewertung erklaerst du dich mit den AGBs und der Datenschutzerklaerung einverstanden.
        </span>
      </label>
      <a href="/email-confirm" data-submit-inquiry="true" className="w-full mobile-btn-main-h bg-[#0099ff] text-white radius-24 shadow-lg hover:bg-blue-600 transition transform active:scale-95 text-base uppercase tracking-wide flex items-center justify-center">
        Jetzt kostenlos bewerten!
      </a>
    </div>
  </div>
)

const DesktopFinTab = () => (
  <div id="desktop-tab-content-fin" data-tab-content-group="desktop" data-tab-target="fin" className="hidden">
    <div className="flex items-center space-x-2 w-full mb-4">
      <input id="desktop-fin-input" type="text" placeholder="WDD169 0071J236589" className="flex-1 min-w-0 mobile-input-h pl-4 pr-2 radius-24 text-center text-gray-900 text-base outline-none" />
      <button type="button" id="desktop-fin-scan" className="flex-none mobile-btn-scan-h px-6 bg-[#0099ff] text-white radius-24 text-sm shadow-md flex items-center justify-center cursor-pointer hover:bg-blue-600 transition">Scan</button>
    </div>
    <div className="relative w-full radius-24 overflow-hidden border-2 border-dashed border-blue-200 mb-0 bg-white">
      <img src="/images/FIN.png" alt="Fahrzeugschein Beispiel" className="w-full object-contain" />
      <div className="absolute bottom-2 left-0 right-0 flex justify-center">
        <label className="bg-[#0099ff] text-white text-xs py-1.5 px-4 rounded-full shadow-md hover:bg-blue-600 transition cursor-pointer">
          <span>Zulassung (ZB 1) Foto hochladen</span>
          <input id="desktop-fin-upload" type="file" className="hidden" accept="image/*" capture="environment" />
        </label>
      </div>
    </div>
    <div id="desktop-fin-step-1" className="form-step fin-form-step fin-first-step relative mb-0">
      <select id="desktop-fin-year" className="w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Erstzulassung</option>
        {finYearOptions.map((year) => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-fin-step-2" className="form-step fin-form-step relative">
      <select id="desktop-fin-mileage" className="w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Kilometer</option>
        {finMileageOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-fin-step-3" className="form-step fin-form-step relative">
      <input type="email" id="desktop-fin-email" placeholder="E-Mail" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none" />
    </div>
    <div id="desktop-fin-step-4" className="form-step fin-form-step flex space-x-2">
      <div className="relative w-1/3">
        <select id="desktop-fin-phone-code" className="w-full mobile-input-h pl-3 pr-6 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none truncate">
          <option>+49</option>
          <option>+43</option>
          <option>+41</option>
          <option>+41</option>
        </select>
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
        </div>
      </div>
      <input id="desktop-fin-phone-prefix" type="text" inputMode="numeric" maxLength={4} placeholder="Vorwahl" className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
      <input id="desktop-fin-phone-number" type="text" inputMode="numeric" maxLength={8} placeholder="Telefon-Nr." className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
    </div>
    <div id="desktop-fin-step-6" className="form-step fin-form-step mt-4">
      <label className="flex items-start space-x-3 cursor-pointer mb-4 text-white text-sm opacity-90">
        <input type="checkbox" className="custom-radio mt-1" />
        <span>
          Mit Anforderung der Online-Bewertung erklaerst du dich mit den AGBs und der Datenschutzerklaerung einverstanden.
        </span>
      </label>
      <a href="/email-confirm" data-submit-inquiry="true" className="w-full mobile-btn-main-h bg-[#0099ff] text-white radius-24 shadow-lg hover:bg-blue-600 transition text-lg tracking-wide flex items-center justify-center">
        Fertig
      </a>
    </div>
  </div>
)

const DesktopHsnTab = () => (
  <div id="desktop-tab-content-hsn" data-tab-content-group="desktop" data-tab-target="hsn" className="hidden">
    <div className="flex items-center space-x-2 w-full mb-4">
      <input id="desktop-hsn" type="text" placeholder="HSN" maxLength={4} className="flex-1 min-w-0 w-1/3 mobile-input-h px-2 radius-24 text-center text-gray-900 text-base outline-none" />
      <input id="desktop-tsn" type="text" placeholder="TSN" maxLength={3} className="flex-1 min-w-0 w-1/3 mobile-input-h px-2 radius-24 text-center text-gray-900 text-base outline-none" />
      <button type="button" id="desktop-hsn-scan" className="flex-none mobile-btn-scan-h px-4 bg-[#0099ff] text-white radius-24 text-sm shadow-md flex items-center justify-center">Scan</button>
    </div>
    <div className="relative w-full radius-24 overflow-hidden border-2 border-dashed border-blue-200 bg-white mb-0">
      <img src="/images/HSN.png" alt="HSN/TSN Beispiel" className="w-full object-contain" />
      <div className="absolute bottom-2 left-0 right-0 flex justify-center">
        <label className="bg-[#0099ff] text-white text-xs py-1.5 px-4 rounded-full shadow-md hover:bg-blue-600 transition cursor-pointer">
          <span>Zulassung (ZB 1) Foto hochladen</span>
          <input id="desktop-hsn-upload" type="file" className="hidden" accept="image/*" capture="environment" />
        </label>
      </div>
    </div>
    <div id="desktop-hsn-step-1" className="form-step relative">
      <select id="desktop-hsn-year" className="w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Erstzulassung</option>
        {hsnYearOptions.map((year) => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-hsn-step-2" className="form-step relative">
      <select id="desktop-hsn-mileage" className="w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Kilometer</option>
        {hsnMileageOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="desktop-hsn-step-3" className="form-step relative">
      <input type="email" id="desktop-hsn-email" placeholder="E-Mail" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none" />
    </div>
    <div id="desktop-hsn-step-4" className="form-step flex space-x-2">
      <div className="relative w-1/3">
        <select id="desktop-hsn-phone-code" className="w-full mobile-input-h pl-3 pr-6 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none truncate">
          <option>+49</option>
          <option>+43</option>
          <option>+41</option>
          <option>+41</option>
        </select>
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
        </div>
      </div>
      <input id="desktop-hsn-phone-prefix" type="text" inputMode="numeric" maxLength={4} placeholder="Vorwahl" className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
      <input id="desktop-hsn-phone-number" type="text" inputMode="numeric" maxLength={8} placeholder="Telefon-Nr." className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
    </div>
    <div id="desktop-hsn-step-6" className="form-step mt-4 space-y-3">
      <div className="text-white text-legal opacity-90">Den autoverkaufen.de Nutzungsbedignungen stimme ich zu.</div>
      <label className="flex items-start space-x-3 cursor-pointer agb-consent">
        <input type="checkbox" className="custom-radio mt-1" />
        <span className="text-white text-legal opacity-90">
          Ich bin mit dem Erhalt der Bewertung per E-Mail einverstanden.
          Mit Anforderung der Online-Bewertung erklaerst du dich mit den AGBs und der Datenschutzerklaerung einverstanden.
        </span>
      </label>
      <a href="/email-confirm" data-submit-inquiry="true" className="w-full mobile-btn-main-h bg-[#0099ff] text-white radius-24 shadow-lg hover:bg-blue-600 transition text-lg tracking-wide flex items-center justify-center">
        Fertig
      </a>
    </div>
  </div>
)

const MobileFinTab = () => (
  <div id="tab-content-fin" data-tab-content-group="mobile" data-tab-target="fin" className="hidden space-y-0">
    <div className="flex items-center space-x-2 w-full mb-4">
      <input id="mobile-fin-input" type="text" placeholder="WDD169 0071J236589" className="flex-1 min-w-0 mobile-input-h pl-4 pr-2 radius-24 text-center text-gray-900 text-base outline-none" />
      <button type="button" id="mobile-fin-scan" className="flex-none mobile-btn-scan-h px-6 bg-[#0099ff] text-white radius-24 text-sm shadow-md flex items-center justify-center cursor-pointer hover:bg-blue-600 transition">Scan</button>
    </div>
    <div className="relative w-full radius-24 overflow-hidden border-2 border-dashed border-blue-200 mb-0 bg-white">
      <img src="/images/FIN.png" alt="Fahrzeugschein Beispiel" className="w-full object-contain" />
      <div className="absolute bottom-2 left-0 right-0 flex justify-center">
        <label className="bg-[#0099ff] text-white text-xs py-1.5 px-4 rounded-full shadow-md hover:bg-blue-600 transition cursor-pointer">
          <span>Zulassung (ZB 1) Foto hochladen</span>
          <input id="mobile-fin-upload" type="file" className="hidden" accept="image/*" capture="environment" />
        </label>
      </div>
    </div>
    <div id="fin-step-1" className="form-step fin-form-step fin-first-step relative mb-0">
      <select id="fin-year" className="w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Erstzulassung</option>
        {finYearOptions.map((year) => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="fin-step-2" className="form-step fin-form-step relative">
      <select id="fin-mileage" className="w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Kilometer</option>
        {finMileageOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="fin-step-3" className="form-step fin-form-step relative">
      <input type="email" id="fin-email" placeholder="E-Mail" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none" />
    </div>
    <div id="fin-step-4" className="form-step fin-form-step flex space-x-2">
      <div className="relative w-1/3">
        <select id="fin-phone-code" className="w-full mobile-input-h pl-3 pr-6 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none truncate">
          <option>+49</option>
          <option>+43</option>
          <option>+41</option>
          <option>+41</option>
        </select>
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
        </div>
      </div>
      <input id="fin-phone-prefix" type="text" inputMode="numeric" maxLength={4} placeholder="Vorwahl" className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
      <input id="fin-phone-number" type="text" inputMode="numeric" maxLength={8} placeholder="Telefon-Nr." className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
    </div>
    <div id="fin-step-5" className="form-step fin-form-step mt-4">
      <div className="text-white text-legal mb-2">
        Den autoverkaufen.de Nutzungsbedignungen stimme ich zu.
      </div>
      <label className="flex items-start space-x-3 cursor-pointer mb-4 agb-consent">
        <input type="checkbox" className="custom-radio mt-1" />
        <span className="text-white text-legal opacity-90">
          Ich bin mit dem Erhalt der Bewertung per E-Mail einverstanden.
          Mit Anforderung der Online-Bewertung erklaerst du dich mit den AGBs und der Datenschutzerklaerung einverstanden.
        </span>
      </label>
      <a href="/email-confirm" data-submit-inquiry="true" className="w-full mobile-btn-main-h bg-[#0099ff] text-white radius-24 shadow-lg hover:bg-blue-600 transition text-lg tracking-wide flex items-center justify-center">
        Fertig
      </a>
    </div>
  </div>
)

const MobileHsnTab = () => (
  <div id="tab-content-hsn" data-tab-content-group="mobile" data-tab-target="hsn" className="hidden">
    <div className="flex items-center space-x-2 w-full mb-4">
      <input id="mobile-hsn" type="text" placeholder="HSN" maxLength={4} className="flex-1 min-w-0 w-1/3 mobile-input-h px-2 radius-24 text-center text-gray-900 text-base outline-none" />
      <input id="mobile-tsn" type="text" placeholder="TSN" maxLength={3} className="flex-1 min-w-0 w-1/3 mobile-input-h px-2 radius-24 text-center text-gray-900 text-base outline-none" />
      <button type="button" id="mobile-hsn-scan" className="flex-none mobile-btn-scan-h px-4 bg-[#0099ff] text-white radius-24 text-sm shadow-md flex items-center justify-center">Scan</button>
    </div>
    <div className="relative w-full radius-24 overflow-hidden border-2 border-dashed border-blue-200 bg-white mb-0">
      <img src="/images/HSN.png" alt="HSN/TSN Beispiel" className="w-full object-contain" />
      <div className="absolute bottom-2 left-0 right-0 flex justify-center">
        <label className="bg-[#0099ff] text-white text-xs py-1.5 px-4 rounded-full shadow-md hover:bg-blue-600 transition cursor-pointer">
          <span>Zulassung (ZB 1) Foto hochladen</span>
          <input id="mobile-hsn-upload" type="file" className="hidden" accept="image/*" capture="environment" />
        </label>
      </div>
    </div>
    <div id="hsn-step-2" className="form-step relative">
      <select id="hsn-year" className="w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Erstzulassung</option>
        {hsnYearOptions.map((year) => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="hsn-step-3" className="form-step relative">
      <select id="hsn-mileage" className="w-full mobile-input-h pl-5 pr-10 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none">
        <option value="">Kilometer</option>
        {hsnMileageOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    <div id="hsn-step-4" className="form-step relative">
      <input type="email" id="hsn-email" placeholder="E-Mail" className="w-full mobile-input-h px-5 bg-white radius-24 text-gray-900 text-base shadow-sm outline-none" />
    </div>
    <div id="hsn-step-5" className="form-step flex space-x-2">
      <div className="relative w-1/3">
        <select id="hsn-phone-code" className="w-full mobile-input-h pl-3 pr-6 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none truncate">
          <option>+49</option>
          <option>+43</option>
          <option>+41</option>
        </select>
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
        </div>
      </div>
      <input id="hsn-phone-prefix" type="text" inputMode="numeric" maxLength={4} placeholder="Vorwahl" className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
      <input id="hsn-phone-number" type="text" inputMode="numeric" maxLength={8} placeholder="Telefon-Nr." className="w-1/3 mobile-input-h px-3 bg-white radius-24 text-gray-900 text-sm shadow-sm outline-none text-center" />
    </div>
    <div id="hsn-step-6" className="form-step mt-4">
      <div className="text-white text-legal mb-2">
        Den autoverkaufen.de Nutzungsbedignungen stimme ich zu.
      </div>
      <label className="flex items-start space-x-3 cursor-pointer mb-4 agb-consent">
        <input type="checkbox" className="custom-radio mt-1" />
        <span className="text-white text-legal opacity-90">
          Ich bin mit dem Erhalt der Bewertung per E-Mail einverstanden.
          Mit Anforderung der Online-Bewertung erklaerst du dich mit den AGBs und der Datenschutzerklaerung einverstanden.
        </span>
      </label>
      <a href="/email-confirm" data-submit-inquiry="true" className="w-full mobile-btn-main-h bg-[#0099ff] text-white radius-24 shadow-lg hover:bg-blue-600 transition text-lg tracking-wide flex items-center justify-center">
        Fertig
      </a>
    </div>
  </div>
)

const LandingHero = () => (
<>
  {/* DESKTOP HERO (Hidden on mobile) */}
  <section id="desktop-hero" className="hidden md:flex relative bg-scroll bg-no-repeat md:bg-[#f0e7e3] md:min-h-[85vh] flex-col justify-center md:pb-0" style={{backgroundImage: 'url("/images-optimized/BG_Start.gif")', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container flex flex-col mx-auto xl:px-20 relative z-10">
      <div id="hero-row" className="flex flex-col md:flex-row items-center md:justify-between gap-8 px-4 lg:px-12">
        <div id="hero-form-col" className="flex justify-center mt-8 w-full md:max-w-[420px] flex-shrink-0 z-10">
          {/* Full form */}
          <div className="w-full max-w-sm md:w-[400px] md:bg-brand-fuchsia md:rounded-[2.5rem] md:shadow-2xl p-6 md:p-8 pb-16 md:pb-8">
            {/* LOGO */}
            <div className="flex justify-center mb-8 mt-4">
              <img src="/images/Logo.svg" alt="Logo autoverkaufen.de" className="w-full h-auto object-contain" />
            </div>
            {/* FORM */}
            <div className="mt-4">
              <form className="space-y-4 md:space-y-2">
                <div className="mobile-tab-header">
                  <div className="tab-btn-wrapper">
                    <span className="tip-label mobile-tip">TIPP</span>
                    <button type="button" id="desktop-tab-btn-fin" data-tab-group="desktop" data-tab-target="fin" className="tab-btn rounded-t-xl px-6 py-3 tracking-wide">FIN</button>
                  </div>
                  <button type="button" id="desktop-tab-btn-model" data-tab-group="desktop" data-tab-target="model" className="tab-btn active rounded-t-xl px-4 py-3 tracking-wide">Marke/Model</button>
                  <button type="button" id="desktop-tab-btn-hsn" data-tab-group="desktop" data-tab-target="hsn" className="tab-btn rounded-t-xl px-4 py-3 tracking-wide">HSN/TSN</button>
                </div>
                <div id="desktop-tab-content-window" className="dark-purple-box p-5 rounded-b-3xl rounded-tl-3xl rounded-tr-3xl shadow-2xl relative z-10">
                  {/* FIN Tab (Desktop styled like mobile) */}
                  <DesktopFinTab />
                  <DesktopModelSteps />
                  <DesktopHsnTab />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div id="topFrameContainer" className="relative hidden md:flex justify-center items-end flex-1 h-[760px] lg:h-[800px] pr-2 lg:pr-6 overflow-visible">
          <iframe id="topIframe" className="absolute left-1/2 -translate-x-1/2 scale-110 lg:scale-125 lazy max-w-none" scrolling="no" data-src="/ani/home/frame.htm" width={10} height={10} data-aos="fade-up" data-aos-duration={1500} style={{maxWidth: 'none'}} />
        </div>
      </div>
      {/* Desktop Brands / Trust Bar */}
      <div className="hidden md:flex relative justify-around items-center gap-12 mt-16 pb-8 max-w-5xl mx-auto w-full px-6">
        <div className="partner-logo-wrap group">
          <span className="partner-tooltip">Unser Partner fuer eine akkurate Preiskalkulation</span>
          <img src="/images-optimized/Dat_grau_high.svg" loading="lazy" alt="DAT" className="h-14 w-auto" />
        </div>
        <div className="partner-logo-wrap group">
          <span className="partner-tooltip">Unser Partner fuer die serioese Fahrzeugbewertung</span>
          <img src="/images-optimized/Mobile_grau.svg" loading="lazy" alt="mobile.de" className="h-10 w-auto" />
        </div>
        <div className="partner-logo-wrap group">
          <span className="partner-tooltip">Unser Partner fuer die qualifizierte Fahrzeugpruefung</span>
          <img src="/images-optimized/Dekra_grau.svg" loading="lazy" alt="DEKRA" className="h-10 w-auto" />
        </div>
      </div>
    </div></section>
  {/* MOBILE HERO */}
  <section className="md:hidden bg-[#3E4150]">
    {/* Purple Top Section */}
    <div className="mobile-hero-gradient pt-8 px-4 relative z-10 shadow-xl">
      <div className="flex justify-center mb-6">
        <img src="/images/Logo.svg" alt="autoverkaufen.de" className="w-full max-w-[360px] md:max-w-full h-auto object-contain" />
      </div>
      <div className="text-center mb-6">
        <h2 className="text-white text-[25px] tracking-wide">Was ist mein Auto wert?</h2>
      </div>
      {/* TABS HEADER */}
      <div className="mobile-tab-header">
        <div className="tab-btn-wrapper">
          <span className="tip-label mobile-tip">TIPP</span>
          <button type="button" id="tab-btn-fin" data-tab-group="mobile" data-tab-target="fin" className="tab-btn rounded-t-xl px-6 py-3 tracking-wide">FIN</button>
        </div>
        <button type="button" id="tab-btn-model" data-tab-group="mobile" data-tab-target="model" className="tab-btn active rounded-t-xl px-4 py-3 tracking-wide">Marke/Model</button>
        <button type="button" id="tab-btn-hsn" data-tab-group="mobile" data-tab-target="hsn" className="tab-btn rounded-t-xl px-4 py-3 tracking-wide">HSN/TSN</button>
      </div>
      {/* DARK PURPLE CONTENT BOX */}
      <div id="tab-content-container" className="dark-purple-box p-5 rounded-b-3xl rounded-tl-3xl rounded-tr-3xl shadow-2xl relative z-10 -mt-[1px]">
        {/* TAB CONTENT: FIN (Mobile) */}
        <MobileFinTab />
        <MobileModelSteps />
        {/* TAB CONTENT: HSN/TSN (Mobile) */}
        <MobileHsnTab />
      </div>
    </div>
    {/* Partner Logos Mobile */}
    <div className="flex md:hidden relative justify-around items-center gap-6 px-4 py-6 max-w-md mx-auto">
      <div className="partner-logo-wrap">
        <img src="/images-optimized/Dat_grau_high.svg" className="h-12 w-auto" alt="DAT" />
      </div>
      <div className="partner-logo-wrap">
        <img src="/images-optimized/Mobile_grau.svg" className="h-10 w-auto" alt="mobile.de" />
      </div>
      <div className="partner-logo-wrap">
        <img src="/images-optimized/Dekra_grau.svg" className="h-10 w-auto" alt="DEKRA" />
      </div>
    </div>
    {/* 3 Steps Section (Mobile) */}
    <div className="text-center px-4 mb-8 space-y-1">
      <div className="text-[58px] font-black text-brand-lime leading-[0.95]">Auto</div>
      <div className="text-[22px] font-semibold text-white leading-tight">verkaufen in</div>
      <div className="flex items-end justify-center gap-2 leading-none">
        <span className="text-[64px] font-black text-brand-lime leading-[0.9]">3</span>
        <span className="text-[40px] font-black text-white mb-[2px]">Schritten</span>
      </div>
    </div>
    {/* Step Cards (Mobile) */}
    {/* ... same ... */}
    <div className="px-5 space-y-5 max-w-sm mx-auto pb-12">
      <div className="bg-white rounded-full p-1.5 flex items-center shadow-lg relative h-24 overflow-visible">
        <div className="flex flex-col pl-6 z-10 w-2/3">
          <p className="text-[10px] text-pink-500 font-bold uppercase tracking-widest mb-0.5">Schritt</p>
          <div className="flex items-center">
            <span className="text-5xl font-black text-brand-lime mr-3 leading-none">1</span>
            <h4 className="text-sm text-gray-800 leading-tight font-normal-override">kostenfreie<br />Online- Bewertung</h4>
          </div>
        </div>
        <div className="absolute right-1 top-1 bottom-1 w-24 h-22 rounded-full bg-blue-100 border-4 border-white overflow-hidden shadow-inner flex items-center justify-center">
          <img src="/images-optimized/Icon_Foto.gif" className="object-cover w-full h-full scale-125 translate-y-2" />
        </div>
      </div>
      <div className="bg-white rounded-full p-1.5 flex items-center shadow-lg relative h-24 overflow-visible">
        <div className="flex flex-col pl-6 z-10 w-2/3">
          <p className="text-[10px] text-pink-500 font-bold uppercase tracking-widest mb-0.5">Schritt</p>
          <div className="flex items-center">
            <span className="text-5xl font-black text-brand-lime mr-3 leading-none">2</span>
            <h4 className="text-sm text-gray-800 leading-tight font-normal-override">Bestpreis<br />erhalten</h4>
          </div>
        </div>
        <div className="absolute right-1 top-1 bottom-1 w-24 h-22 rounded-full bg-purple-100 border-4 border-white overflow-hidden shadow-inner flex items-center justify-center">
          <img src="/images-optimized/Icon_Bewertung.gif" className="object-cover w-full h-full scale-110" />
        </div>
      </div>
      <div className="bg-white rounded-full p-1.5 flex items-center shadow-lg relative h-24 overflow-visible">
        <div className="flex flex-col pl-6 z-10 w-2/3">
          <p className="text-[10px] text-pink-500 font-bold uppercase tracking-widest mb-0.5">Schritt</p>
          <div className="flex items-center">
            <span className="text-5xl font-black text-brand-lime mr-3 leading-none">3</span>
            <h4 className="text-sm text-gray-800 leading-tight font-normal-override">Fahrzeug abgeben<br />sofort Geld erhalten</h4>
          </div>
        </div>
        <div className="absolute right-1 top-1 bottom-1 w-24 h-22 rounded-full bg-orange-100 border-4 border-white overflow-hidden shadow-inner flex items-center justify-center">
          <img src="/images-optimized/Icon_Partner.gif" className="object-cover w-full h-full scale-110" />
        </div>
      </div>
    </div>
  </section>
</>
)

export default LandingHero
